// test1180
(1180 && 0);
